import { FluxStandardAction } from 'redux-promise-middleware';
import { Listeners } from '../actions/listenerActions';
import { ActionTypes as ModalActionTypes } from '../actions/modalActions';
import Modal from '../models/Modal';
import { ModalType as BroadcastFacultyModal } from '../viewcomponents/Modals/BroadcastFacultyModal';
import { ModalType as BroadcastModal } from '../viewcomponents/Modals/BroadcastModal';
import { ModalType as DeleteQueueModal } from '../viewcomponents/Modals/DeleteQueueModal';
import { ModalType as HideQueueModal } from '../viewcomponents/Modals/HideQueueModal';
import { ModalType as PurgeQueueModal } from '../viewcomponents/Modals/PurgeQueueModal';
import { ModalType as RenameQueueModal } from '../viewcomponents/Modals/RenameQueueModal';
import { ModalType as SendBadLocationModal } from '../viewcomponents/Modals/SendBadLocationModal';
import { ModalType as SendMessageModal } from '../viewcomponents/Modals/SendMessageModal';
import { ModalType as SetMotdModal } from '../viewcomponents/Modals/SetMotdModal';
import { ModalType as SetQueueInformationModal } from '../viewcomponents/Modals/SetQueueInformationModal';
import { ModalType as SetServerMessageModal } from '../viewcomponents/Modals/ServerMessageModal';
import { ModalType as AddBannerModal } from '../viewcomponents/Modals/AddBannerModal';
import { ModalType as UpdateBannerModal } from '../viewcomponents/Modals/UpdateBannerModal';
import { ModalType as ShowMessageModal } from '../viewcomponents/Modals/ShowMessageModal';
import { ModalType as ShowMotdModal } from '../viewcomponents/Modals/ShowMotdModal';
import { ModalType as ShowQueueModal } from '../viewcomponents/Modals/ShowQueueModal';
import { ModalType as ManageBookingsModal } from '../viewcomponents/Modals/ManageBookingsModal';
import { ModalType as TodayBookingsModal } from '../viewcomponents/Modals/TodayBookingsModal';
import { ModalType as SelectHelperModal } from '../viewcomponents/Modals/SelectHelperModal';

const initialState = {
  modalList: [] as Modal[],
  current: 0
};

export default (state = initialState, action: FluxStandardAction) => {
  switch (action.type) {

    case Listeners.OnMessageReceived: {
      return { ...state, modalList: [...state.modalList, new Modal(ShowMessageModal, action.payload)] }
    }

    case ModalActionTypes.CloseModal: {
      const nextState = {
        current: state.current + 1,
        modalList: [ ...state.modalList ]
      };

      nextState.modalList[state.current] = nextState.modalList[state.current].clone();
      nextState.modalList[state.current].hide();

      return nextState;
    }

    case ModalActionTypes.RemoveModal: {
      if (state.modalList.some(modal => modal.isVisible)) {
        return state;
      }

      return initialState;
    }

    case ModalActionTypes.OpenSendMessageModal: {
      return { ...state, modalList: [...state.modalList, new Modal(SendMessageModal, action.payload)] }
    }

    case ModalActionTypes.OpenBroadcastModal: {
      return { ...state, modalList: [...state.modalList, new Modal(BroadcastModal, action.payload)] }
    }

    case ModalActionTypes.OpenBroadcastFacultyModal: {
      return { ...state, modalList: [...state.modalList, new Modal(BroadcastFacultyModal, action.payload)] }
    }

    case ModalActionTypes.OpenSetMotdModal: {
      return { ...state, modalList: [...state.modalList, new Modal(SetMotdModal, action.payload)] }
    }

    case ModalActionTypes.OpenSetQueueInformationModal: {
      return { ...state, modalList: [...state.modalList, new Modal(SetQueueInformationModal, action.payload)] }
    }

    case ModalActionTypes.OpenSetServerMessageModal: {
      return { ...state, modalList: [...state.modalList, new Modal(SetServerMessageModal)] }
    }

    case ModalActionTypes.OpenAddBannerModal: {
      return { ...state, modalList: [...state.modalList, new Modal(AddBannerModal)] }
    }

    case ModalActionTypes.OpenUpdateBannerModal: {
      return { ...state, modalList: [...state.modalList, new Modal(UpdateBannerModal, action.payload)] }
    }

    case ModalActionTypes.OpenShowQueueModal: {
      return { ...state, modalList: [...state.modalList, new Modal(ShowQueueModal, action.payload)] }
    }

    case ModalActionTypes.OpenHideQueueModal: {
      return { ...state, modalList: [...state.modalList, new Modal(HideQueueModal, action.payload)] }
    }

    case ModalActionTypes.OpenPurgeQueueModal: {
      return { ...state, modalList: [...state.modalList, new Modal(PurgeQueueModal, action.payload)] }
    }

    case ModalActionTypes.OpenDeleteQueueModal: {
      return { ...state, modalList: [...state.modalList, new Modal(DeleteQueueModal, action.payload)] }
    }

    case ModalActionTypes.OpenRenameQueueModal: {
      return { ...state, modalList: [...state.modalList, new Modal(RenameQueueModal, action.payload)] }
    }

    case ModalActionTypes.OpenShowMotdModal: {
      return { ...state, modalList: [...state.modalList, new Modal(ShowMotdModal, action.payload)] }
    }

    case ModalActionTypes.OpenSendBadLocationModal: {
      return { ...state, modalList: [...state.modalList, new Modal(SendBadLocationModal, action.payload)] }
    }

    case ModalActionTypes.OpenManageBookingsModal: {
      return { ...state, modalList: [...state.modalList, new Modal(ManageBookingsModal, action.payload)] }
    }

    case ModalActionTypes.OpenTodayBookingsModal: {
      return { ...state, modalList: [...state.modalList, new Modal(TodayBookingsModal, action.payload)] }
    }

    case ModalActionTypes.OpenSelectHelperModal: {
      return { ...state, modalList: [...state.modalList, new Modal(SelectHelperModal, action.payload)] }
    }

  }

  return state;
};
